var _style, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilePdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 507.9 636.2",
    style: {
      enableBackground: "new 0 0 507.91 636.23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st3{fill:#ea551e}.st5{fill:#cad1d8}.st6{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
    d: "M346.3 50.7h.5l.5.7c.4 1.5.4 3 .4 4.5 0 30.2.3 60.5-.2 90.7a31.5 31.5 0 0 0 28.5 31.2l1.6.2c1.7.4 2.8 1.5 4 2.6l91.3 91.4c.9.9 1.9 1.7 2.2 3 .2 1.4.2 2.8.2 4.1v251.6c0 13.8-8.6 26-21.6 30.7-2.6.9-5.2.9-7.8 1.2H120.4c-14.5.6-27.8-12.5-30-26.6-.4-2.4-.6-4.9-.6-7.4v-42c0-1.4 0-8 1.2-4 1.2.9 1 2.2 1 3.3l.1 8.4c0 3.2.1 3.3 3.4 3.3h296.8c3.9 0 7.6-.5 10.9-2.8a14 14 0 0 0 6.2-10.6c.4-5.1.5-10.2.2-15.3V308c0-3.6-.7-7-2.8-10-3-4.4-7.5-6.3-12.7-6.6H95.8c-1.7 0-3.5.3-5.1-.7-.8-.7-.9-1.6-1-2.6V84.8c0-7.7 1.8-14.9 6.4-21.1 6-8.2 13.9-13.2 24.4-12.8h222.7c1 0 2.1.3 3-.2z",
    style: {
      fill: "#e1e4e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446 562.4v.5H120v-.5h326z",
    style: {
      fill: "#f5f6f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.4 51.2v-.5h225.9c-.8.8-1.8.4-2.7.5H120.4z",
    style: {
      fill: "#ebedef"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M40.9 482.4a16.1 16.1 0 0 1-14-16.2L26.8 307c0-7.6 5.7-16.4 16.4-16.4h44.6l2.9-.1h302c2.2 0 4.4.2 6.6.9 6.5 2 11 8 11.2 14.8v162.5c-1.2 9.4-7.1 14.6-16.7 14.6H95.1c-17.7-1.6-35.5-.4-53.3-.8l-1-.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m346.8 51.2 2 1.7c41 41.2 82.2 82.3 123.3 123.4l1.8 2c-.1 1.1-1.1 1.1-2 1.3-1 .2-2 0-3 0l-84.9.1c-2 0-3.8-.2-5.6-1-9.3 0-17.1-3.5-23.3-10.2a29.6 29.6 0 0 1-8.4-20.6V51.2z",
    style: {
      fill: "#b0b7bd"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M40.9 482.4h352.3c2 0 4 0 6-.7a16 16 0 0 0 10.8-11.2c.1-.6 0-1.3.5-1.8 0 5 .3 10 0 14.8a15.7 15.7 0 0 1-12.7 14.6c-1.7.4-3.5.5-5.2.5H94.9c-4.1 0-3.7.4-3.7-3.7V485c0-.7.2-1.6-.6-2.2H43.2c-.8 0-1.6.1-2.3-.4zM378.4 178.8H471c1 0 2.1.3 3-.6.7.7.4 1.5.4 2.3v93.7c-.9-.5-1.5-1.4-2.3-2.1l-90.8-90.8-2.8-2.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M182.5 390.4v-34.7c0-6.3 3.4-9.6 9.6-9.6h29.7c9.3 0 17.9 2.5 25.4 8 8 6 13 14 15.4 23.6a48 48 0 0 1-2.3 31.7 38.9 38.9 0 0 1-37.2 25c-10.6.3-21.1 0-31.7 0-1.8 0-3.5-.2-5-1a6.8 6.8 0 0 1-3.7-5.4c-.2-1-.2-2-.2-3v-34.6zM96.5 389.6V355c0-1.7.1-3.4.9-5 1.4-3 3.8-5 7.2-5 11.4 0 22.7-.5 34 .3 11.7.8 23.5 8.3 26.8 23.5 1.8 8 1.4 15.9-2.3 23.4a29.4 29.4 0 0 1-23.2 16.4c-4 .6-8 .3-12 .4h-12.7c-1.7 0-1.7 0-1.7 1.7v13c0 1.1 0 2.3-.2 3.5-.4 3.9-2.8 6.6-6.2 7.2a8.7 8.7 0 0 1-9.8-4.8c-.7-1.6-.8-3.2-.8-4.9v-35zM281.7 390v-36.2c.3-4.3 3-7.2 7.4-7.7h47.7c4 .2 6.8 2.4 7.6 5.7.9 3.7-.7 7.6-4 9.6a11 11 0 0 1-5.9 1.3H302c-4 0-3.4-.4-3.4 3.5V381c0 2 0 2 2 2h30c4 0 7 2 8.8 5.4 1.8 3.2 1.1 6.5-1.6 8.9-2 1.7-4.4 2.5-7 2.5h-30.8c-1.1-.2-1.5.4-1.5 1.5V426.5c0 2.3-.6 4.4-2.4 6-2.6 2.4-5.8 2.4-9 1.4-3-1-4.8-3.1-5.2-6.3l-.1-2.6v-35z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M199.5 390.5v-26.6c0-2.2 0-2.2 2-2.2 7.1 0 14.2-.3 21.3.1 11.3.8 18.8 6.7 22.4 17.3 3.2 9 2.5 18-2 26.4a24 24 0 0 1-21.7 13.4c-6.7.2-13.4 0-20.1 0-1.9 0-1.9 0-1.9-1.9v-26.5zM113.5 376.8V363c0-1.9 0-1.9 1.8-1.9h19.6c6.9.1 12.7 5 14.6 11.8a15.8 15.8 0 0 1-11 19.5c-1.3.3-2.4.4-3.6.4h-19.4c-2 0-2 0-2-2v-13.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePdf);
export default __webpack_public_path__ + "static/media/file-pdf.624af137d5ea3ae00864c52e48c4ae55.svg";
export { ForwardRef as ReactComponent };